import { AbstractControl, FormGroup } from '@angular/forms';
import {
    CompleteSortieCommand,
    DisplayableMissionDto,
    SortieDto
} from '@flyfreely-portal-ui/flyfreely';
import { Observable } from 'rxjs';
import { DisplayableResource } from '../mission-completion.service';

/**
 * This defines the interface that is used to provide central functions from the mission completion services
 */
export abstract class MissionCompletionOrRecordService<
    T extends { [K in keyof T]: AbstractControl<any> } = any
> {
    abstract availablePersonnel$: Observable<DisplayableResource[]>;
    abstract working$: Observable<boolean>;
    abstract savedMission$: Observable<DisplayableMissionDto>;
    abstract form: FormGroup<T>;
    abstract updateMissionFromSortieCommand(
        sortieCommand: CompleteSortieCommand[],
        mission: DisplayableMissionDto
    ): Observable<DisplayableMissionDto>;
    abstract updateFlights(flights: SortieDto[]): void;
    abstract addFlight(flight: SortieDto): void;
    abstract updateFlight(flight: SortieDto): void;
}
